import React from 'react';
import { Form } from 'react-bootstrap';

const ReactstrapFormikLabel = ({ field: { ...fields }, ...props }) => {
    const { id } = props;
    return (
        <Form.Group controlId={id} className="form-group">
            {props.label && <Form.Label className={'label-color'}>{props.label}</Form.Label>}
            <p className="pb-1">{fields.value}</p>
        </Form.Group>
    );
};
export default ReactstrapFormikLabel;
